// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jvztU","content":"styles_content__1jzF4","row":"styles_row__skSWI","footer":"styles_footer__k7VaH","phraseLength":"styles_phraseLength__3yqdF"};